import type { Directive } from 'vue'

const tooltip: Directive = {
  mounted(el, binding) {
    if (binding.value) {
      el.setAttribute('title', binding.value)
    }
  },
  updated(el, binding) {
    if (binding.value !== binding.oldValue) {
      if (binding.value) {
        el.setAttribute('title', binding.value)
      } else {
        el.removeAttribute('title')
      }
    }
  },
  unmounted(el) {
    el.removeAttribute('title')
  }
}

export default tooltip
